import React from "react";
import { Typography, Grid, Button, Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

const useStyles = makeStyles((theme) => ({
    header: {
        color: theme.palette.ePrimary.base,
        fontWeight: "bold",
        marginLeft: "1rem"
    },
    back: {
        color: theme.palette.ePrimary.base,
        fontWeight: "bold"
    },
    divider: {
        marginTop: "1rem",
        marginBottom: "1rem"
    },
    backGrid: {
        display: "grid",
    },
}))
export default function EHeader(props) {
    const { activeStep, setActiveStep, handleClickOpen } = props;
    const summaryClass = useStyles();
    const summaryReviewLabel = useSelector((state) => state?.labels?.data?.getLabels?.E_SUMMARY_REVIEW);
    const backCall = () => {
        if (activeStep === 0) {
            handleClickOpen();
        } else {
            setActiveStep(activeStep - 1)
        }
    };
    return (
        <>
            <Grid container spacing={2}>
                <Grid item className={summaryClass.backGrid}>
                    <Button
                        className={summaryClass.back}
                        size="small"
                        startIcon={<ArrowBackIosIcon fontSize="small" />}
                        onClick={backCall}
                        align="left"
                    >
                        <Typography variant="button" className={summaryClass.back}>{summaryReviewLabel?.E_BACK_LABEL}</Typography>
                    </Button>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="h5" className={summaryClass.header}>
                        {summaryReviewLabel?.E_MAIN_TITLE}
                    </Typography>
                </Grid>
            </Grid>
            <Divider className={summaryClass.divider} />
        </>
    )
}